import React, { useState } from "react";
// import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Carousel from 'react-bootstrap/Carousel';
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import sliderpreviousIcon from "../assets/img/slider-previous-icon.svg";
import slidernextIcon from "../assets/img/slider-next-icon.svg";

import downloadepdficon from '../assets/img/download-pdf-icon.svg';
import brochurePdf1 from '../assets/img/pdf/elixir-brochur.pdf';
import brochurePdf2 from '../assets/img/pdf/elixir-printing.pdf';
import brochurePdf3 from '../assets/img/pdf/elixir-arsign.pdf';
import brochurePdf4 from '../assets/img/pdf/elixir-label.pdf';
import brochurePdf5 from '../assets/img/pdf/elixir-exhibitions.pdf';
import brochurePdf6 from '../assets/img/pdf/elixir-signages.pdf';
import brochurePdf7 from '../assets/img/pdf/elixir-safety.pdf';
import brochurePdf8 from '../assets/img/pdf/elixir-packaging.pdf';
import brochurePdf9 from '../assets/img/pdf/elixir-gifts.pdf';
import brochurePdf10 from '../assets/img/pdf/elixir-restaurant.pdf';
import brochurePdf11 from '../assets/img/pdf/elixir-digital-signages.pdf';

function Home() {

  // useEffect(()=>{
  //   document.title = 'Elixir | Home';
  // }, []);

  // Scroll Counter Up Start
  const [counterOn, setCounterState] = useState(false); 
  // Scroll Counter Up End

  // Project Slider Start
  const PrevArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <img src={sliderpreviousIcon} className="img-fluid" alt="elixir" />
    </div>
  );
  
  const NextArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <img src={slidernextIcon} className="img-fluid" alt="elixir" />
    </div>
  );

  
  // Team Slider Start
  var settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    centerMode: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,  
    focusOnSelect: true,
    pauseOnHover:false,  
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  // Team Slider End

  // Testimonials Slider Start
  var settings3 = {
    dots: true,
    infinite: true,
    speed: 600,
    cssEase: 'linear',
    fade: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    // prevArrow: <PrevArrow />,
    // nextArrow: <NextArrow />,
    focusOnSelect: true,
    pauseOnHover:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  // Testimonials Slider End

  return (
    <>    
    <section className="homeCategory">
      <Container>
          <Row>            
            <Col lg={3} md={6}>
              <Link to="/Brandingandgraphicdesign" className="homeCategory-box1" data-aos="fade-up" data-aos-duration="3000">
                <h4>Branding & Design</h4>
                <p>Designing Brands That Speak. Creating Impact That Lasts.</p>
                <img src={require('../assets/img/home-banner-img-1.jpg')} className="img-fluid" alt="elixir"  />
              </Link>
            </Col>  
            <Col lg={6} md={6}>
              <div className="homeCategory-box2" data-aos="fade-up" data-aos-duration="3000">
                <Carousel fade>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-1.jpg')} className="img-fluid" alt="elixir" />
                    <Carousel.Caption>
                      {/* <h3>Elixir World</h3> */}
                    </Carousel.Caption>
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-2.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-3.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-4.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-5.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-6.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-7.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-8.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-9.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-10.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-11.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-12.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-13.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-14.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={require('../assets/img/home-service-slider-15.jpg')} className="img-fluid" alt="elixir" />
                  </Carousel.Item>
                </Carousel>
              </div>
            </Col>          
            <Col lg={3} md={6}>
              <Link to="/signageoutdoor" className="homeCategory-box1" data-aos="fade-up" data-aos-duration="3000">
                <h4 className="signageTitle">Signage <span>(Outdoor, Indoor, Industrial)</span></h4>
                <p>The Ultimate Signage: Outdoor, Indoor, Industrial, Safety & Digital.</p>
                <img src={require('../assets/img/home-banner-img-2.jpg')} className="img-fluid" alt="elixir"  />
              </Link>
            </Col>  
            <Col lg={6} md={6}>
              <Link to="/Eventservices" className="homeCategory-box3" data-aos="fade-up" data-aos-duration="3000">
                <h4 className="mb-3">Events & Exhibitions</h4>
                <img src={require('../assets/img/home-banner-img-3.jpg')} className="img-fluid" alt="elixir"  />
              </Link>
            </Col>
            <Col lg={3} md={6}>
              <Link to="/Webdesignservices" className="homeCategory-box1" data-aos="fade-up" data-aos-duration="3000">
                <h4>Web & Social Media</h4>
                <p>Engaging. Interactive. Shareable. Accessible. Influential. Dynamic.</p>
                <img src={require('../assets/img/home-banner-img-4.jpg')} className="img-fluid" alt="elixir"  />
              </Link>
            </Col>  
            <Col lg={3} md={6}>
              <Link to="/printingservices" className="homeCategory-box1" data-aos="fade-up" data-aos-duration="3000">
                <h4>Printing & Packaging</h4>
                <p>High-Quality Printing & Packaging with Purpose.</p>
                <img src={require('../assets/img/home-banner-img-5.jpg')} className="img-fluid" alt="elixir"  />
              </Link>
            </Col>  
        </Row>
      </Container>
    </section>
    <section className="downloadBro">
      <Container>
        <Row>        
          <Col lg={12}>
            <div className="brocureBox brocureBox-mobile" id="downloadBrochures">
            <h3>Download Brochure</h3>
            <a href={brochurePdf1} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-brochur-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Brochur</h4>
            </a>
            <a href={brochurePdf2} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-printing-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Printing</h4>
            </a>
            <a href={brochurePdf3} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-arsign-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>AR Sign</h4>
            </a>     
            <a href={brochurePdf4} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-label-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Label</h4>
            </a>       
            <a href={brochurePdf5} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-exhibitions-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Exhibitions</h4>
            </a>
            <a href={brochurePdf6} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-signages-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Signages</h4>
            </a>   
            <a href={brochurePdf7} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-safety-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Safety</h4>
            </a>
            <a href={brochurePdf8} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-packaging-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Packaging</h4>
            </a>
            <a href={brochurePdf9} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-gifts-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Gifts</h4>
            </a>
            <a href={brochurePdf10} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-restaurant-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Restaurant</h4>
            </a>
            <a href={brochurePdf11} className="brocureBox-file" target="_blank">
              <div className="brocureBox-img">
                <img src={require('../assets/img/elixir-digital-img-1.jpg')} className="brocureBox-img-main img-fluid" alt="elixir" />
                <img src={downloadepdficon} className="brocureBox-img-download" alt="elixir" />
              </div>
              <h4>Digital</h4>
            </a>
          </div>
          </Col>
        </Row>  
      </Container>  
    </section>  
    <section className="homeService">
      <Container>
        <div className="homeService-img" data-aos="fade-up" data-aos-duration="3000">
          <Row>  
            <Col lg={9} md={12}>      
            <div className="homeService-title">
              <h2 class="home-h2">WE ARE <br /><hr /><strong class="color-yellow">HERE</strong> FOR <strong class="color-gray">YOU</strong></h2>
              <p><em>Think Branding. Think Digital. Think Exhibitions, Events & Corporate Gifts.</em></p>
              <p>Think Elixir & AR Graphics – an award-winning, ISO 9001-certified design agency with a pan-Gulf presence.</p>
              <p>We are the GCC’s only integrated creative hub, offering end-to-end, in-house capabilities. With a strategic presence in Saudi Arabia, UAE, and India, our customer-focused teams deliver across multidimensional platforms.</p>
              <p>For over a decade, we have partnered with some of the region’s most quality-driven international brands, helping them achieve impactful, world-class results.</p>
              <h6>Elixir & AR Graphics – your local agency for global excellence.</h6>
              <h4>Quality and Commitment.</h4>
            </div>
            </Col>
            <Col lg={3} md={12}>              
              <ScrollTrigger className="homeCounter-counter" onEnter={()=> setCounterState(true)} onExit={()=> setCounterState(false)} >
                <h4>
                  <span className="media-count-value">{counterOn && <CountUp start={0} end={250} duration={4} delay={0}/>} <span className="homeCounter-plus">+</span></span>                  
                  <span className="homeCounter-title">CLIENTS ADD</span>
                </h4>
                <h4>
                <span className="media-count-value">{counterOn && <CountUp start={0} end={5000} duration={4} delay={0}/>} <span className="homeCounter-plus">+</span></span>                  
                  <span className="homeCounter-title">COMPLETED PROJECTS</span>  
                </h4>
                <h4>
                <span className="media-count-value">{counterOn && <CountUp start={0} end={25} duration={4} delay={0}/>} <span className="homeCounter-plus">+</span></span>
                  <span className="homeCounter-title">YEARS OF EXPERIENCE</span>  
                </h4>
                <h4>
                <span className="media-count-value">{counterOn && <CountUp start={0} end={50} duration={4} delay={0}/>} <span className="homeCounter-plus">+</span></span>
                  <span className="homeCounter-title">Expert Staff</span>  
                </h4>
              </ScrollTrigger>  
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    <section className="latestWork">
      <Container>
        <Row>
          <Col lg={12}>
            <h2 data-aos="fade-up" data-aos-duration="3000">LATEST <span>PROJECTS</span></h2> 
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Brandingandgraphicdesign">
                <img src={require('../assets/img/work/work-img1.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Signageoutdoor">
                <img src={require('../assets/img/work/work-img2.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Signageindoor">
                <img src={require('../assets/img/work/work-img3.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Signageindustrial">
                <img src={require('../assets/img/work/work-img4.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Digitalsignage">
                <img src={require('../assets/img/work/work-img5.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Printingservices">
                <img src={require('../assets/img/work/work-img6.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Eventservices">
                <img src={require('../assets/img/work/work-img7.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Exhibitionservices">
                <img src={require('../assets/img/work/work-img8.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Webdesignservices">
                <img src={require('../assets/img/work/work-img9.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Corporateservices">
                <img src={require('../assets/img/work/work-img10.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/Tradingservices">
                <img src={require('../assets/img/work/work-img11.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
            <div class="latestWork-box homeProj">
              <Link to="/ITsolutions">
                <img src={require('../assets/img/work/work-img12.jpg')} className="img-fluid" alt="elixirworld"  />
                <div class="overlay">
                  <div class="text">
                    <h4>BEST</h4>
                    <p>Brand Identity</p>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    <section className="clientlogo">
    <Container>
      <Row>
        <Col lg={12}>
          <h2 data-aos="fade-up" data-aos-duration="3000">Our <span>Clients</span></h2>
          <Col lg={12} data-aos="zoom-in" data-aos-duration="3000">
          <Slider {...settings2}>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-1.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-2.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-3.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-4.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>  
            <div className="clientlogo-box">
              <img src={require('../assets/img/client/client-logo-5.jpg')} className="img1 img-fluid" alt="elixir" />
            </div>  
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-6.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>  
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-7.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>  
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-8.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-9.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-10.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-11.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-12.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-13.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-14.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-15.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-16.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-17.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-18.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-19.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-20.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-21.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-22.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-23.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-24.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-25.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-26.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-27.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-28.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-29.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-30.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-31.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-32.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div> 
            <div className="clientlogo-box">
              <a href="/Clients">
                <img src={require('../assets/img/client/client-logo-33.jpg')} className="img1 img-fluid" alt="elixir" />
              </a>
            </div>  
          </Slider>
        </Col> 
        </Col>
      </Row>
    </Container>
    </section>
    <section className="footerServices">
      <Container>        
        <Row>
          <Col lg={12}>
            <h2 data-aos="fade-up" data-aos-duration="3000">A FULL <span>SERVICE</span></h2> 
          </Col>
          <Col xs={6} md={4} lg data-aos="fade-up" data-aos-duration="3000">
            <h4>
              <Link to="/Brandingandgraphicdesign">Design</Link>
            </h4>
            <ul>
              <li>
                <Link to="/Brandingandgraphicdesign">Logo Design</Link>
              </li>
              <li>
                <Link to="/Brandingandgraphicdesign">Brand Identity</Link>
              </li>
              <li>
                <Link to="/Brandingandgraphicdesign">Brand Auditing</Link>
              </li>
              <li>
                <Link to="/Printingservices">Brochure Design</Link>
              </li>
              <li>
                <Link to="/Printingservices">Product Design</Link>
              </li>
              <li>
                <Link to="/Brandingandgraphicdesign">Annual Reports</Link>
              </li>
              <li>
                <Link to="/Printingservices">Print Services</Link>
              </li>
            </ul>
          </Col>
          <Col xs={6} md={4} lg data-aos="fade-up" data-aos-duration="3000">
            <h4>
              <Link to="#">Signage</Link>
            </h4>
            <ul>
              <li>
                <Link to="/Signageoutdoor">Digital Displays</Link>
              </li>
              <li>
                <Link to="/Signageoutdoor">LED Signs</Link>
              </li>
              <li> 
                <Link to="/Signageoutdoor">Channel Letters</Link>
                </li>
              <li>
                <Link to="/Signageindoor">Wall Graphics</Link>
                </li>
              <li>
                <Link to="/Signageindoor">Floor Decals</Link>
                </li>
              <li>
                <Link to="/Signageindoor">Menu Boards</Link>
                </li>
              <li>
                <Link to="/Signageindoor">Acrylic Signs</Link>
                </li>
              <li>
                <Link to="/Signageindoor">Retail Signage</Link>
                </li>
              <li>
                <Link to="/Signageindustrial">Hospitality Signs</Link>
                </li>
              <li>
                <Link to="/Signageindustrial">Industrial Safety Signs</Link>
                </li>
              <li>
                <Link to="/Signageindustrial">Corporate Branding</Link>
              </li>
              <li>
                <Link to="/Signageindustrial">Real Estate Signs</Link>
              </li>
            </ul>
          </Col>
          <Col xs={6} md={4} lg data-aos="fade-up" data-aos-duration="3000">
            <h4>
              <Link to="#">Exhibitions</Link>
            </h4>
            <ul>
              <li>
                <Link to="/Exhibitionservices">Theme Conceptualization</Link>
              </li>
              <li>
                <Link to="/Exhibitionservices">Trade Show Technology</Link>
              </li>
              <li> 
                <Link to="/Exhibitionservices">Digital Event Services</Link>
                </li>
              <li>
                <Link to="/Eventservices">Photo and Videography</Link>
                </li>
              <li>
                <Link to="/Eventservices">Live Streaming</Link>
                </li>
              <li>
                <Link to="/Eventservices">Event Planning</Link>
                </li>
              <li>
                <Link to="/Eventservices">Award Ceremonies</Link>
                </li>
              <li>
                <Link to="/Exhibitionservices">Exhibition Promotion</Link>
                </li>
              <li>
                <Link to="/Eventservices">Product Launches</Link>
                </li>
              <li>
                <Link to="/Eventservices">Booth/Stand Design</Link>
                </li>
              <li>
                <Link to="/Eventservices">Event Advertising</Link>
              </li>
            </ul>
          </Col>
          <Col xs={6} md={4} lg data-aos="fade-up" data-aos-duration="3000">
            <h4><Link to="#">Digital & Website</Link></h4>
            <ul>
              <li>
                <Link to="/Webdesignservices">Website Design</Link>
              </li>
              <li>
                <Link to="/Webdesignservices">Mobile Apps</Link>
              </li>
              <li>
                <Link to="/Webdesignservices">Content Management System</Link>
              </li>
              <li>
                <Link to="/Webdesignservices">E-commerce Solutions</Link>
              </li>
              <li>
                <Link to="/Webdesignservices">Custom Web Applications</Link>
              </li>
              <li>
                <Link to="/Socialmediamarketing">Social Media Management</Link>
              </li>
              <li>
                <Link to="/Socialmediamarketing">Analytics & Performance Tracking</Link>
              </li>
              <li>
                <Link to="/Socialmediamarketing">Email Marketing</Link>
              </li>
              <li>
                <Link to="/Socialmediamarketing">Branding & Graphic Design</Link>
                </li>
              <li>
                <Link to="/Socialmediamarketing">Online Marketing</Link>
              </li>
            </ul>
          </Col>  
          <Col xs={6} md={4} lg data-aos="fade-up" data-aos-duration="3000">
            <h4><Link to="#">General Trading</Link></h4>
            <ul>
              <li>
                <Link to="/Tradingservices">Printing Equipment</Link>
              </li>
              <li>
                <Link to="/Tradingservices">Digital Printing Machines</Link>
              </li>
              <li>
                <Link to="/Tradingservices">UV Printing Machines</Link>
              </li>
              <li>
                <Link to="/Tradingservices">Packaging Printing Equipment</Link>
              </li>
              <li>
                <Link to="/Tradingservices">Technical Support Services</Link>
              </li>
              <li>
                <Link to="/Tradingservices">Spare Parts & Consumables</Link>
              </li>
              <li>
                <Link to="/Tradingservices">Used Printing Machinery Sales</Link>
              </li>
            </ul>  
          </Col>
        </Row>
      </Container>
    </section>
    </>
  );
}

export default Home;
